import { useQuery } from "react-query";
import { format } from "date-fns";

import { Proposal } from "../../models";
import { RQ } from "../../globals/enums";
import { getAll } from "../../api/generic-api";

export const useProposalsByFilter = (
  startDate: Date,
  endDate?: Date,
  workOrderStates?: string[],
  workOrderId?: string,
  customerId?: string
) => {
  let params = new URLSearchParams();
  startDate && params.append("startDate", format(startDate, "yyyy-MM-dd"));
  endDate && params.append("endDate", format(endDate, "yyyy-MM-dd"));
  workOrderStates &&
    workOrderStates.length > 0 &&
    params.append("workOrderStates", workOrderStates.join(","));
  customerId && params.append("customerId", customerId);
  workOrderId && params.append("workOrderId", workOrderId);
  return useQuery<Proposal[], Error>(
    [RQ.PROPOSALS],
    async () => await getAll(`proposals/filter?${params}`),
    {
      enabled: Boolean(startDate && endDate),
    }
  );
};
